import * as React from 'react';
import { AppBar, Button, Snackbar, Stack, Toolbar, Typography, useScrollTrigger } from '@mui/material';
import NightModeToggle from './NightModeToggle';
import { Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import FormBox from "@mui/material/Box";
import { sendContactUsInfo } from '../../services/ContactUsInfo';
import { ContactUs, newContactUs } from '../../data/contactUsData';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';

export default function Footer() {
    const [open, setOpen] = React.useState(false);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [formData, setFormData] = React.useState<ContactUs>(newContactUs);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSnackbarOpen = () => setSnackbarOpen(true);
    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            await sendContactUsInfo(formData);
            handleSnackbarOpen();
            setOpen(false);
            
        } catch (error: any) {
            alert("Failed to send message: " + error.message);
        }
    }

    return (
        <>
            <ElevationScroll>
                <AppBar position="fixed" sx={{ top: 'auto', bottom: 0 }}>
                    <Toolbar>
                        <Button><Link className='social' to='/'>© 2024 Windy City Conference</Link></Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

                        </Typography>
                        <Button className='social' onClick={handleOpen}>Contact Us</Button>
                        <Button><Link className='social' to='/code-of-conduct'>Code of Conduct</Link></Button>
                        <Button><Link className='social' to='/privacy-terms'>Privacy and Terms</Link></Button>
                        {/* <Button><Link className='social' to='/community-guidelines'>Community Guidelines</Link></Button> */}
                        {/* <Button> <Link className='social' to='/faq'>FAQ</Link></Button> */}

                        <NightModeToggle />

                    </Toolbar>
                </AppBar>
            </ElevationScroll>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='contactModal'
            >
                <FormBox
                    component="form"
                    onSubmit={handleSubmit}
                    className='contactFormModal'
                >
                <h5 className='uppercase'>Get in touch with us</h5>
                <h1 className='uppercase'>Contact Us</h1>
                <div className='contact-form-container'>
                    <TextField id="name-input" label="Name" name="Name" className='inputText' size="small" fullWidth onChange={handleChange} 
                        variant="outlined" required InputLabelProps={{  sx: { color: "#777777"} }} inputProps={{ style: { color: "#777777" } }}
                    />

                    <TextField id="email-input" label="Email" name="EmailAddress" fullWidth className='inputText' size="small" onChange={handleChange} 
                        variant="outlined" required InputLabelProps={{  sx: { color: "#777777"} }} inputProps={{ style: { color: "#777777" } }}
                    />

                    <TextField id="role-input" label="Role" name="Role" className='inputText halfWidth' defaultValue="" size="small"
                        onChange={handleChange} variant="outlined" InputLabelProps={{  sx: { color: "#777777"} }} inputProps={{ style: { color: "#777777" } }}
                    />

                    <TextField id="organization-input" label="Organization" name="Organization" className='inputText halfWidth' onChange={handleChange} 
                        defaultValue="" size="small" variant="outlined" InputLabelProps={{  sx: { color: "#777777"} }} inputProps={{ style: { color: "#777777" } }}
                    />

                    <TextField id="message-input" label="Message"  name="Message" className='inputText' fullWidth onChange={handleChange} defaultValue="" 
                        variant="outlined"  required  multiline rows={4} maxRows={6} InputLabelProps={{  sx: { color: "#777777"} }} inputProps={{ style: { color: "#777777" } }}
                    /></div>


                <p className='smallText'>* Required Fields</p>
                <Stack direction="row" spacing={4} marginTop={1}>
                    <Button
                    variant="contained" endIcon={<CloseIcon />}
                    color='error'
                    onClick={handleClose}
                    className='button'
                >
                    Close
                    </Button>
                        <Button
                            variant="contained" endIcon={<SendIcon />}
                            color='success'
                            type='submit'
                            className='button'
                        >
                        Submit
                    </Button>
                </Stack>
                </FormBox>
            </Modal>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message="Thank you for your message!"
                action={
                    <Button color="secondary" size="small" onClick={handleSnackbarClose}>
                        Close
                    </Button>
                }
            />
        </>
    );
}

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

function ElevationScroll(props: Props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}